<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        v-on="on"
      >
        <v-icon color="hrissecondary">
          mdi-plus-circle
        </v-icon>
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Fixed Deduction/Earning"
      text="Create Fixed Deduction/Earning"
      class="mb-0"
    >
      <form v-if="!loading">
        <v-container>
          <v-row>
            <v-col
              cols="12"
              class="pb-0"
            >
              <v-autocomplete
                v-model="deductionOrEarning"
                v-validate="'required'"
                :items="deductionOrEarnings"
                item-text="name"
                item-value="id"
                label="Deduction/Earning"
                :error-messages="errors.collect('deductionOrEarning')"
                data-vv-name="deductionOrEarning"  
                data-vv-as="deduction/earning"
                outlined
              />
            </v-col>

            <v-col
              cols="12"
              class="pb-0"
            >
              <v-text-field
                v-model="amount"
                v-money="money"
                label="Amount"
                prefix="RM"
                outlined
              />
            </v-col>

            <v-col
              cols="12"
              class="pb-0"
            >
              <v-menu
                v-model="startDateMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
                max-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="startDateDisplay"
                    v-validate="'required'"
                    :error-messages="errors.collect('startDateDisplay')"
                    data-vv-name="startDateDisplay"
                    data-vv-as="start date"
                    label="Start date"
                    outlined
                    readonly
                    class="label-position"
                    v-on="on"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon>
                        mdi-calendar
                      </v-icon>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="startDate"
                  no-title
                  :min="companyEmployeeStartDate"
                  @input="startDateMenu = false"
                />
              </v-menu>
            </v-col>
          </v-row>
        </v-container>
      </form>

      <v-card-actions>
        <v-spacer />
        <v-btn
          class="px-10"
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"    
          class="white--text px-10"     
          @click="submitForm"
        >
          Submit
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  import { VMoney } from 'v-money'
  export default {
    directives: { money: VMoney },
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      existingDoes: {
        type: Array,
        required: true,
      },
      companyEmployeeUid: {
        type: String,
        required: true,
      },
      companyEmployeeStartDate: {
        type: String,
        required: true,
      },
    },
    data () {
      return {
        startDateMenu: false,
        startDate: null,
        deductionOrEarnings: [],
        deductionOrEarning: null,
        loading: false,
        progressing: false,
        dialog: false,
        amount: null,
        money: {
          decimal: '.',
          thousands: ',',
          precision: 2,
          masked: false, /* doesn't work with directive */
        },
      }
    },
    computed: {
      startDateDisplay () {
        return this.startDate ? this.$moment(this.startDate, 'YYYY-MM-DD').format('DD-MM-YYYY') : ''
      },
    },
    watch: {
      dialog: function (value) {
        if (!value) return this.$resetData() 
        this.loading = true

        this.$api.deductionOrEarnings().list()
          .then(res => {
            let existingDoesId = this.existingDoes.filter(doe => {
              return !doe.end_date
            }).map(doe => {
              return doe.deduction_or_earning_id
            })

            this.deductionOrEarnings = _.orderBy(res.data.filter(doe => {
              return !existingDoesId.includes(doe.id)
            }), ['.name'], ['asc'])

            this.loading = false
          })
      },
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return
          
            this.progressing = true

            this.$api.companyEmployeeDeductionOrEarnings().create(this.companyEmployeeUid, this.prepareFormData())
              .then(res => {
                this.$emit('created')
                this.$snack({ message: res.data.status })
                
                this.progressing = false
                this.dialog = false
              })
          })
      },
      prepareFormData () {
        return {
          deduction_or_earning_id: this.deductionOrEarning,
          start_date: this.startDate,
          amount: this.amount.toString().replaceAll(',', ''),
        }
      },
    },
  }
</script>

<style scoped>
.label-position >>> .v-label.v-label--active{
  margin-left:-28px;
  background:white;
  padding-right:5px
}
</style>
